import cn from "classnames";
import type React from "react";

interface Props {
  active?: boolean;
}

const DotIcon: React.FC<Props> = ({ active }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
      className={cn({
        "fill-green-600": active,
        "fill-gray-300": !active,
      })}
    >
      <g filter="url(#filter0_dd_270_10813)">
        <circle cx="11" cy="10" r="8" fill="#fff"></circle>
        <circle cx="11" cy="10" r="4" fill="currentFill"></circle>
      </g>
      <defs>
        <filter
          id="filter0_dd_270_10813"
          width="22"
          height="22"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="1"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.160784 0 0 0 0 0.2 0 0 0 0 0.160784 0 0 0 0.06 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_270_10813"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="1"></feOffset>
          <feGaussianBlur stdDeviation="1.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.160784 0 0 0 0 0.2 0 0 0 0 0.160784 0 0 0 0.1 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_270_10813"
            result="effect2_dropShadow_270_10813"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_270_10813"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default DotIcon;
